import { Routes, RouterModule } from "@angular/router";

import { MTACardManagerComponent } from "./mtacardmanager/mtacardmanager.component";
import { UserAdministrationComponent } from "./user-administration/user-administration.component";
import { UserGroupAdministrationComponent } from "./user-group-administration/user-group-administration.component";
import { UserGroupAssignmentComponent } from "./user-group-assignment/user-group-assignment.component";
import { ManageSchoolContainerComponent } from "./manage-school-container/manage-school-container.component";
import { ManageRolesComponent } from "./manage-roles/manage-roles.component";
import { RoleAdminSUComponent } from "./role-admin-su/role-admin-su.component";
import { AuthguardService } from "../master/services";
import { SSOMaintenanceComponent } from "./sso-maintenance/sso-maintenance.component";

export const SysAdminRoutes: Routes = [
	{ path: "", redirectTo: "/sysadmin/roles", pathMatch: "full" },

	{
		path: "mtacardschool",
		data: { title: "School MTA Card Manager" },
		component: MTACardManagerComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "users",
		data: { title: "User Administration" },
		component: UserAdministrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "usergroups",
		data: { title: "User Group Administration" },
		component: UserGroupAdministrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "usergroupassign",
		data: { title: "User Group Assignment" },
		component: UserGroupAssignmentComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "roles",
		data: { title: "Roles" },
		component: ManageRolesComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "schoolcontainer",
		data: { title: "School Container" },
		component: ManageSchoolContainerComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "rolessu",
		data: { title: "Role Maintenance (SU Only)" },
		component: RoleAdminSUComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "ssomaintenance",
		data: { title: "SSO Maintenance (SU Only)" },
		component: SSOMaintenanceComponent,
		canActivate: [AuthguardService],
	},
];
